import React from 'react';
import config from '../utils/Dotenv';
import Grid from '@material-ui/core/Grid';
import HomeStyles from '../sass/partials/_home.module.scss';

export default class Media extends React.Component<{}, {}> {
  public render(): React.ReactElement {
    return (
      <Grid container className={HomeStyles.grid}>
        <h1 className={HomeStyles.title}>{config.TITLE}</h1>
        <img
          src={config.BACKGROUND_IMAGE}
          className={HomeStyles.image}
          alt="ANLB Building" />
      </Grid>
    );
  }
}